import { Box } from "@mui/system";
import { createFileRoute } from "@tanstack/react-router";
import { PageContainer } from "src/components/page-container";
import { StripePricingTable } from "src/components/stripe/strip-pricing-table";

export const Route = createFileRoute("/_authenticated/organizacao/faturamento/mudar-plano")({
  component: () => <Page />,
});

const Page = () => {
  return (
    <PageContainer title="Mudar de Plano" subtitle="Escolha um plano e prossiga para o Stripe.">
      <Box>
        <StripePricingTable />
      </Box>
    </PageContainer>
  );
};
